import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';
import { ToastRef } from './toast-ref';

export interface ToastData {
  message: string;
  action?: string;
  type?: 'success' | 'danger' | 'info' | 'warning';
  duration?: number;
}

@Component({
  selector: 'app-toast',
  template: `
    <div
      class="toast bg-{{
        data.type || 'info'
      }} show border-0"
      role="alert"
    >
      <div
        class="d-flex justif-content-between"
        *ngIf="!data.action"
      >
        <div class="toast-body">
          {{ data.message }}
        </div>
        <button
          type="button"
          class="btn-close btn-close-white me-2 m-auto"
          (click)="ref.close()"
        ></button>
      </div>
      <ng-container *ngIf="data.action">
        <div class="toast-body">
          {{ data.message }}
        </div>
        <div
          class="d-flex justify-content-end p-2 border-top"
        >
          <button
            type="button"
            class="btn btn-sm btn-primary"
            (click)="ref.close()"
          >
            {{ data.action }}
          </button>
        </div>
      </ng-container>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
  @Input() data!: ToastData;
  ref!: ToastRef;
}
